import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=51a759a0&scoped=true"
import script from "./customer_list.vue?vue&type=script&lang=js"
export * from "./customer_list.vue?vue&type=script&lang=js"
import style0 from "./customer_list.vue?vue&type=style&index=0&id=51a759a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a759a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a759a0')) {
      api.createRecord('51a759a0', component.options)
    } else {
      api.reload('51a759a0', component.options)
    }
    module.hot.accept("./customer_list.vue?vue&type=template&id=51a759a0&scoped=true", function () {
      api.rerender('51a759a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/product_adjustment/form/customer_list.vue"
export default component.exports